import React, { useState, useEffect } from "react";
import moment from "moment";
import "moment-duration-format";

const Calculation = ({ Ordertime, compact = false }) => {
    const [countup, setCountup] = useState("00:00");
    const [urgency, setUrgency] = useState("green");

    useEffect(() => {
        const currentDate = new Date().toLocaleDateString("en-CA");
        const testTime = `${currentDate} ${Ordertime}`;

        const startDate = moment(testTime, "YYYY-MM-DD HH:mm:ss");
        let secondsDiff = moment().diff(startDate, "seconds");

        const update = () => {
            secondsDiff++;

            const duration = moment.duration(secondsDiff, "seconds");

            const format = compact ? "hh:mm" : "hh:mm:ss";

            setCountup(
                duration.format(format, {
                    trim: false,
                })
            );

            if (secondsDiff >= 900) {
                // 15+ min
                setUrgency("red");
            } else if (secondsDiff >= 600) {
                // 10+ min
                setUrgency("orange");
            } else if (secondsDiff >= 300) {
                // 5+ min
                setUrgency("yellow");
            } else {
                setUrgency("green");
            }
        };

        update();

        const interval = setInterval(update, 1000);

        return () => clearInterval(interval);
    }, [Ordertime, compact]);

    const styles = {
        green:
            "bg-green-100 text-green-700 border border-green-200",
        yellow:
            "bg-yellow-100 text-yellow-800 border border-yellow-200",
        orange:
            "bg-orange-100 text-orange-800 border border-orange-200",
        red:
            "bg-red-100 text-red-700 border border-red-200 animate-pulse",
    };

    const dots = {
        green: "🟢",
        yellow: "🟡",
        orange: "🟠",
        red: "🔴",
    };

    return (
        <div
            className={`inline-flex items-center gap-1 rounded-full font-mono font-semibold transition-all duration-300 ${compact
                    ? "px-1.5 py-0.5 text-[10px]"
                    : "px-2.5 py-1 text-xs tracking-wider"
                } ${styles[urgency]}`}
        >
            <span>{dots[urgency]}</span>
            <span>{countup}</span>
        </div>
    );
};

export default Calculation;